import {
	Box,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import { useState } from "react";
import CommCard from "src/common/CommCard";
import { CommonPagination } from "src/common/CommonPagination";
import ModalsWrapper from "src/components/Modals/ModalsWrapper";
import { useGetQueryWithTotal } from "src/hooks/useGetQueryWithTotal";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import type { IB2BMoneyReceiptList } from "../type/b2bType";
import B2BMoneyReceiptTableRow from "./B2BMoneyReceiptTableRow";
import CreateB2BMoneyReceipt from "./CreateB2BMoneyReceipt";

const B2BMoneyReceiptList = () => {
	const [pagination, setPagination] = useState({
		limit: 50,
		skip: 0,
	});
	const [search, setSearch] = useState("");
	const [dateRange, setDateRange] = useState(undefined);
	const { data: B2BMoneyReceiptList, isLoading } = useGetQueryWithTotal<
		IB2BMoneyReceiptList[]
	>({
		endPoint: `/api/admin/b2b/money-receipt`,
		queryKeys: ["b2b-money-receipt"],
		params: { pagination, money_receipt_no: search, dateRange },
	});
	const [open, setOpen] = useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	return (
		<CommCard
			helmetTitle={"BTTF - Account List"}
			headerTitle={`Money Receipt List (${B2BMoneyReceiptList?.total})`}
			showButton
			showCardHeader
			handleBtnForModalFun={handleOpen}
			btnText='Create Money Receipt'
			showSearch
			handleSearchFun={(value) => setSearch(value)}
			showDateRange
			handleDateRange={(value) => setDateRange(value)}
		>
			<>
				<TableContainer>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell>SL.</TableCell>
								<TableCell>Date</TableCell>
								<TableCell>Receipt No.</TableCell>
								<TableCell>B2B Details</TableCell>
								<TableCell>Account Type</TableCell>
								<TableCell>Total Amount</TableCell>
								<TableCell>Action</TableCell>
							</TableRow>
						</TableHead>

						{isLoading ? (
							<TableLoader />
						) : B2BMoneyReceiptList?.data?.length > 0 ? (
							<TableBody>
								{B2BMoneyReceiptList?.data?.map(
									(
										moneyRece: IB2BMoneyReceiptList,
										index
									) => {
										return (
											<B2BMoneyReceiptTableRow
												key={moneyRece.id}
												moneyReceipt={moneyRece}
												serial={index + 1}
												paginationSkip={pagination.skip}
											/>
										);
									}
								)}
							</TableBody>
						) : (
							<TableNotFound />
						)}
					</Table>
				</TableContainer>

				<Box p={2}>
					<CommonPagination
						total={B2BMoneyReceiptList?.total}
						paginationCalFun={(limit: number, skip: number) => {
							setPagination({ limit, skip });
						}}
					/>
				</Box>

				<ModalsWrapper
					showModal={open}
					setShowModal={setOpen}
					modalData={{ title: "Create Money Receipt" }}
				>
					<CreateB2BMoneyReceipt handleClose={handleClose} />
				</ModalsWrapper>
			</>
		</CommCard>
	);
};

export default B2BMoneyReceiptList;
